import { getIsoDateNow } from "@dataseat-dsp-client/lib-reporter/build/helpers/dateISO";
import { getQuickLinks } from "components/DateTime/quickLinksModelUtc";
import endpointMaker from "configuration/endpoints";
import { differenceInSeconds } from "date-fns";
import { HALF_HOUR_MS, parseDate, useTimeoutIntervalEffect } from "helpers";
import request from "http/request";
import { ISOstring, Seconds } from "model/modelTypes";
import { TimeRange } from "model/report/dateRange";
import React from "react";

const FETCH_LAG_TIMEOUT = HALF_HOUR_MS;
const LAG_ERROR_VALUE = -1;

function getFinishDateByTimeRange(range: TimeRange): ISOstring | null {
  const quickLinks = getQuickLinks();
  if (range === TimeRange.allTime) return getIsoDateNow();
  return quickLinks[range]?.value[1] || null;
}

function useLag(dateRange?: TimeRange, finishDate?: ISOstring | null): Seconds {
  const [lag, setLag] = React.useState<Seconds>(0);

  const fetchtLag = React.useCallback(
    () =>
      request
        .getJson(endpointMaker.reporter.lag())
        .then((resp) => {
          const noLag = resp?.lag === LAG_ERROR_VALUE || !resp.lag;
          if (noLag) {
            setLag(0);
          } else {
            const lastFetched = dateRange
              ? getFinishDateByTimeRange(dateRange)
              : finishDate
              ? parseDate(finishDate)
              : null;
            if (!lastFetched) {
              return;
            }

            if (
              differenceInSeconds(parseDate(lastFetched) as Date, new Date()) <
              resp.lag
            ) {
              setLag(resp.lag);
            }
          }
        })
        .catch(() => {
          //silently fall
          //user does not need to know about lag until it's fetcehd and is big
        }),
    [dateRange, finishDate]
  );

  useTimeoutIntervalEffect(fetchtLag, FETCH_LAG_TIMEOUT);

  return lag;
}

export default useLag;
